import * as React from 'react'

const sizeDefault = {
  x: 16,
  y: 16,
}

export interface IProps {
  size?: { x: number; y: number }
  style?: React.CSSProperties
}
export const ScaleY: React.FCC<IProps> = ({ size = sizeDefault, style }) => (
  <svg
    width={size.x}
    height={size.y}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99996 13.7072L8.35351 13.3536L11.3535 10.3536L10.6464 9.64652L8.49996 11.793L8.49996 4.20718L10.6464 6.35363L11.3535 5.64652L8.35352 2.64652L7.99996 2.29297L7.64641 2.64652L4.64641 5.64652L5.35352 6.35363L7.49996 4.20718L7.49996 11.793L5.35352 9.64652L4.64641 10.3536L7.64641 13.3536L7.99996 13.7072Z"
      fill="var(--figma-color-text, rgba(0, 0, 0, 0.8))"
    />
  </svg>
)
